import { render, staticRenderFns } from "./NakesAdd.vue?vue&type=template&id=0933501a&scoped=true"
import script from "./NakesAdd.vue?vue&type=script&lang=js"
export * from "./NakesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0933501a",
  null
  
)

export default component.exports